
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staticly-template/[id]",
      function () {
        return require("private-next-pages/staticly-template/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staticly-template/[id]"])
      });
    }
  